import { CloudArrowDown, DownloadSimple } from '@phosphor-icons/react';
import { useRef, useState } from 'react';
import API from '@/lib/api';
import { toast } from 'sonner';
import { BankImportReview } from './BankImportReview';

export const BankStatementUpload=({busy,setBusy,onResult,onImported})=>{
  const [selectedFiles,setSelectedFiles]=useState([]);
  const [report,setReport]=useState(null);
  const [error,setError]=useState('');
  const lock=useRef(false);
  const upload=async e=>{
    const files=Array.from(e.target.files||[]);if(!files.length||lock.current)return;
    lock.current=true;setBusy(true);onResult(null);setError('');
    try{
      const form=new FormData();files.forEach(file=>form.append('files',file));
      const {data}=await API.post('/bank/afschriften-vergelijk',form,{timeout:180000});
      setSelectedFiles(files);setReport(data);
    }catch(err){onResult({message:err.response?.data?.detail||'Bankafschrift vergelijken mislukt',error:true});}
    finally{lock.current=false;setBusy(false);e.target.value='';}
  };
  const confirm=async()=>{
    if(lock.current||!report)return;
    lock.current=true;setBusy(true);setError('');
    try{
      const form=new FormData();selectedFiles.forEach(file=>form.append('files',file));form.append('preview_hash',report.preview_hash);
      const {data}=await API.post('/bank/afschriften-import',form,{timeout:180000});
      onResult({...data,linked:data.gekoppeld_aan_factuur,imported:data.ingevoegd,
        message:`${data.ingevoegd} nieuwe verrichtingen · ${data.gekoppeld_aan_factuur} factuurbetalingen bevestigd · ${data.niet_gematcht} niet gematcht · ${data.duplicaten_overgeslagen} dubbele vermeldingen niet opnieuw geboekt`});
      if(data.niet_gematcht)toast.warning(`${data.niet_gematcht} betalingen niet gematcht — graag nazien`);
      else toast.success('Bankafschrift verwerkt');
      setReport(null);setSelectedFiles([]);onImported();
    }catch(err){setError(err.response?.data?.detail||(err.code==='ECONNABORTED'?'Het verwerken duurt langer. Controleer Bankverrichtingen voordat u opnieuw probeert; bestaande verrichtingen worden niet dubbel geboekt.':'Bankafschrift importeren mislukt'));}
    finally{lock.current=false;setBusy(false);}
  };
  const template=()=>{const url=URL.createObjectURL(new Blob(['datum;bedrag;valuta;rekening;mededeling;naam;transactie-id\r\n'],{type:'text/csv;charset=utf-8'}));const a=document.createElement('a');a.href=url;a.download='bankafschrift-kolommen.csv';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);};
  return <>
    <label className={`btn btn-secondary inline-flex items-center gap-1.5 ${busy?'opacity-50 pointer-events-none':'cursor-pointer'}`} data-testid="bank-statement-upload-label" title="BNP-pdf, CSV, CODA of CAMT.053 · samen vergelijken mogelijk · EUR · maximaal 10 MB per bestand">
      <CloudArrowDown size={16}/>{busy?'Vergelijken…':'Bankafschrift uploaden'}
      <input type="file" accept=".pdf,.cod,.coda,.txt,.csv,.xml,.camt" multiple hidden disabled={busy} onChange={upload} data-testid="bank-statement-upload" />
    </label>
    <button type="button" className="btn btn-ghost" title="CSV-kolommen downloaden" aria-label="CSV-kolommen downloaden" onClick={template} data-testid="bank-csv-template"><DownloadSimple size={16}/><span className="text-xs">CSV-model</span></button>
    {report&&<BankImportReview report={report} busy={busy} error={error} onClose={()=>{setReport(null);setSelectedFiles([]);}} onImport={confirm}/>}
  </>;
};